var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28.448,
    cy: 22.198,
    r: 7.648,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,236,128)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.128,
    cy: 8.648,
    r: 7.648,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,236,128)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 77.165 45.705 V 89 H 18.291 c -3.013 0 -5.456 -2.443 -5.456 -5.456 V 41.303 l 64.33 1.51 V 45.705 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(209,161,132)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 33.485 36.901 H 17.237 c -2.431 0 -4.402 1.971 -4.402 4.402 v 0 c 0 2.431 1.971 4.402 4.402 4.402 h 59.927 v -8.804 h -9.387",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(198,138,101)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 77.165 68.789 H 62.668 c -0.86 0 -1.557 -0.697 -1.557 -1.557 v -5.215 c 0 -0.86 0.697 -1.557 1.557 -1.557 h 14.497 V 68.789 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(198,138,101)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 77.165 69.789 H 62.668 c -1.41 0 -2.558 -1.146 -2.558 -2.557 v -5.215 c 0 -1.41 1.147 -2.558 2.558 -2.558 h 14.497 c 0.553 0 1 0.447 1 1 v 8.329 C 78.165 69.342 77.718 69.789 77.165 69.789 z M 62.668 61.46 c -0.308 0 -0.558 0.25 -0.558 0.558 v 5.215 c 0 0.307 0.25 0.557 0.558 0.557 h 13.497 V 61.46 H 62.668 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 77.165 90 H 18.291 c -3.56 0 -6.456 -2.896 -6.456 -6.456 V 41.303 c 0 -0.552 0.448 -1 1 -1 s 1 0.448 1 1 v 42.241 c 0 2.457 1.999 4.456 4.456 4.456 h 57.874 V 45.705 c 0 -0.552 0.447 -1 1 -1 s 1 0.448 1 1 V 89 C 78.165 89.553 77.718 90 77.165 90 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 77.165 46.705 H 17.237 c -2.979 0 -5.402 -2.423 -5.402 -5.402 c 0 -2.979 2.423 -5.402 5.402 -5.402 h 16.248 c 0.552 0 1 0.448 1 1 s -0.448 1 -1 1 H 17.237 c -1.876 0 -3.402 1.526 -3.402 3.402 s 1.526 3.402 3.402 3.402 h 58.928 v -6.804 h -8.388 c -0.553 0 -1 -0.448 -1 -1 s 0.447 -1 1 -1 h 9.388 c 0.553 0 1 0.448 1 1 v 8.804 C 78.165 46.258 77.718 46.705 77.165 46.705 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 77.165 42.303 H 18.256 c -0.552 0 -1 -0.448 -1 -1 s 0.448 -1 1 -1 h 58.909 c 0.553 0 1 0.448 1 1 S 77.718 42.303 77.165 42.303 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 70.041 65.625 h -4.527 c -0.553 0 -1 -0.447 -1 -1 s 0.447 -1 1 -1 h 4.527 c 0.553 0 1 0.447 1 1 S 70.594 65.625 70.041 65.625 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 28.445 30.848 c -4.769 0 -8.648 -3.88 -8.648 -8.648 s 3.879 -8.648 8.648 -8.648 s 8.648 3.879 8.648 8.648 S 33.213 30.848 28.445 30.848 z M 28.445 15.552 c -3.666 0 -6.648 2.982 -6.648 6.648 c 0 3.666 2.982 6.648 6.648 6.648 s 6.648 -2.982 6.648 -6.648 C 35.093 18.534 32.11 15.552 28.445 15.552 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "69.69,41.3 62.01,24.13 23.65,41.3 ",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(157,209,132)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "64.29,41.3 59.52,30.65 35.73,41.3 ",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(127,191,96)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 69.695 42.303 H 23.654 c -0.472 0 -0.879 -0.33 -0.978 -0.791 s 0.139 -0.929 0.569 -1.122 l 38.353 -17.173 c 0.24 -0.108 0.517 -0.116 0.765 -0.022 c 0.248 0.095 0.448 0.284 0.557 0.526 l 7.689 17.173 c 0.138 0.31 0.11 0.668 -0.074 0.953 C 70.351 42.131 70.034 42.303 69.695 42.303 z M 28.334 40.303 h 39.818 l -6.65 -14.852 L 28.334 40.303 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 64.287 42.303 H 35.732 c -0.472 0 -0.879 -0.33 -0.978 -0.791 s 0.139 -0.929 0.569 -1.122 L 59.109 29.74 c 0.504 -0.227 1.096 0.001 1.321 0.504 l 4.77 10.651 c 0.138 0.31 0.11 0.668 -0.074 0.953 C 64.942 42.131 64.626 42.303 64.287 42.303 z M 40.412 40.303 h 22.331 l -3.729 -8.33 L 40.412 40.303 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 50.128 17.296 c -4.769 0 -8.648 -3.88 -8.648 -8.648 S 45.359 0 50.128 0 s 8.647 3.879 8.647 8.648 S 54.896 17.296 50.128 17.296 z M 50.128 2 c -3.666 0 -6.648 2.982 -6.648 6.648 c 0 3.666 2.982 6.648 6.648 6.648 c 3.665 0 6.647 -2.982 6.647 -6.648 C 56.775 4.982 53.793 2 50.128 2 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddMoney);
export default __webpack_public_path__ + "static/media/addMoney.bc910f50a6a3ebae5d9158889bc725a5.svg";
export { ForwardRef as ReactComponent };